<template>
  <!-- ユーザ管理画面 -->
  <CCard>
    <CCardHeader>
      <h2>
        <span>休暇申請</span>
        <span class="card-header-actions">
          <!-- 登録画面へ遷移するボタン -->
          <router-link :to="{ name: paidAndSudstituteRegister }">
            <button class="btn btn-primary">新規登録</button>
          </router-link>
        </span>
      </h2>
    </CCardHeader>
    <CCardBody>
      <CRow v-if="errors.length">
        <ul>
          <li style="color: red" v-for="error in errors" :key="error">
            {{ error }}
          </li>
        </ul>
      </CRow>
      <div class="table-responsive">
        <table class="table table-bordered">
          <thead>
            <tr>
              <th scope="col" class="title">ステータス</th>
              <th scope="col" class="title">申請日</th>
              <th scope="col" class="title">種別</th>
              <th scope="col" class="title">開始日</th>
              <th scope="col" class="title">終了日</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="item in items" :key="item.name">
              <td :style="statusColor(item.status)" nowrap>{{ item.status }}</td>
              <td>
                <router-link
                  :to="{ name: paidAndSudstituteInfo, params: { id: item.id } }"
                  >{{ formatDate(item.updated_at) }}</router-link
                >
              </td>
              <td>{{ item.type }}</td>
              <td>{{ formatDate(item.start_day) }}【{{ item.start_time }}】</td>
              <td>
                {{ (item.end_day!=null && item.end_time!=null &&(item.start_day !== item.end_day || item.start_time !== item.end_time)) ? formatDate(item.end_day)+"【"+item.end_time+"】"  : '単日取得' }}
              </td>
              <td>
                <save-button
                  :label="'削除'"
                  :loading="loading"
                  @click="deletePaidAndSubstitute(item.id)"
                  class="btn btn-danger"
                />
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="d-flex justify-content-center">
        <!-- ページング処理 -->
        <VPagination
          v-model="currentPage"
          :click-handler="changePage"
          :page-count="totalPages"
          :force-ellipses="true"
          :container-class="'pagination'"
          :page-class="'page-item'"
          :prev-text="'<'"
          :next-text="'>'"
          :prev-link-class="'page-link'"
          :next-link-class="'page-link'"
          :page-link-class="'page-link'"
          :class-prefix="'pagination'"
        />
      </div>
    </CCardBody>
  </CCard>
</template>

<script>
import ConstList from "./../../ConstList";
import axios from "axios";
import VPagination from "vuejs-paginate";
import SaveButton from '../../common/SaveButton';
export default {
  name: "List",
  components: {
    VPagination,
    SaveButton,
  },
  data() {
    return {
      showModal: false,
      postItem: "",
      items: [],
      employee_id: [],
      deleted_flg: [],
      authority: [],
      errors: [],
      paidAndSudstituteRegister: "",
      paidAndSudstituteInfo: "",
      currentPage: 1,
      pageSize: 10,
      totalPages: 1,
      // 二重サブミット対処フラグ
      submit_flg: false,
      loading: false,
    };
  },

  created() {
    this.paidAndSudstituteRegister = ConstList.ROUTE_PAIDANDSUDSTITUTE_REGISTER;
    this.paidAndSudstituteInfo = ConstList.ROUTE_PAIDANDSUDSTITUTE_INFO;
  },

  computed: {
    // 算出 getter 関数
    time: function () {
      // `this` は vm インスタンスを指します
      return this.message.split("").reverse().join("");
    },
  },

  methods: {
    callList: function () {
      const params = new URLSearchParams();
      params.append("currentPage", this.currentPage);
      params.append("pageSize", this.pageSize);
      {
        axios
          .get(process.env.VUE_APP_API_ORIGIN + "/paidandsubstitute", {
            params: {
              currentPage: this.currentPage,
              pageSize: this.pageSize,
            },
          })
          .then((response) => {
            this.items = response.data;
            if (this.items.length === 0) {
              this.errors.push(ConstList.EMPTY);
            }
            this.items.forEach((element) => {
              // 種別を文字列変換
              const TYPE_NAME = {
                [ConstList.PAID_ID]: ConstList.PAID_NAME,
                [ConstList.SUBSTITUTE_ID]: ConstList.SUBSTITUTE_NAME,
                [ConstList.SPECIAL_ID]: ConstList.SPECIAL,
                [ConstList.ABSENT_ID]: ConstList.ABSENT
              }
              element.type = TYPE_NAME[Number(element.type)] ?? element.type

              if (element.start_time === 1) {
                element.start_time = "終日";
              } else if (element.start_time === 2) {
                element.start_time = "午前";
              } else if (element.start_time === 3) {
                element.start_time = "午後";
              }

              if (element.end_time === 1) {
                element.end_time = "終日";
              } else if (element.end_time === 2) {
                element.end_time = "午前";
              } else if (element.end_time === 3) {
                element.end_time = "午後";
              }
              element.updated_at = element.updated_at.slice(0, 10);
            });
          })
          .catch((error) => {
            axios
            .get(
              `${process.env.VUE_APP_API_ORIGIN}/error/frontError/${error}`
            )
            .then(() => {
              alert(ConstList.SYSTEM_ERROR);
            })
            .catch(() => {
              alert(ConstList.SYSTEM_COMMUNICATION_ERROR);
            });
          });
      }
    },

    // ページ変更
    changePage: function (page) {
      this.currentPage = page;
      this.callList();
    },
    // アイテム数とページサイズに基づいて合計ページ数を計算
    fetchTotalPages: function () {
      const params = new URLSearchParams();
      params.append("year", this.year);
      params.append("month", this.month);
      axios
        .get(process.env.VUE_APP_API_ORIGIN + "/paidandsubstitute/count", {
          params: {
            year: this.year,
            month: this.month,
          },
        })
        .then((response) => {
          const totalCount = response.data;
          this.totalPages = Math.ceil(totalCount / this.pageSize);
        })
        .catch((error) => {
          axios
          .get(
            `${process.env.VUE_APP_API_ORIGIN}/error/frontError/${error}`
          )
          .then(() => {
            alert(ConstList.SYSTEM_ERROR);
          })
          .catch(() => {
            alert(ConstList.SYSTEM_COMMUNICATION_ERROR);
          });
        });
    },

    // モーダルを表示
    openModal: function (item, index) {
      this.postItem = item;
      this.postItem.authority_id = this.authority[index];
      this.showModal = true;
    },

    // 有給代休申請を削除
    deletePaidAndSubstitute: function (id) {
      // 二重サブミット対策
      if (this.submit_flg) return;
      if (confirm("削除してもよろしいですか？")) {
        //フラグがfalseならば、フラグをtrueにしたうえでsubmit
        this.loading = true;
        this.submit_flg = true;
        const params = new URLSearchParams();
        params.append("id", id);
        axios
          .post(
            process.env.VUE_APP_API_ORIGIN + "/paidandsubstituteDelete",
            params
          )
          .then(() => {
            this.submit_flg = false;
            this.$store.commit('set', ['sidebarBadgeRefreshTick', Date.now()]);
            alert(ConstList.DELETE_MESSAGE);
            this.showModal = false;
            window.location.reload();
          })
          .catch((error) => {
            this.submit_flg = false;
            axios
            .get(
              `${process.env.VUE_APP_API_ORIGIN}/error/frontError/${error}`
            )
            .then(() => {
              alert(ConstList.SYSTEM_ERROR);
            })
            .catch(() => {
              alert(ConstList.SYSTEM_COMMUNICATION_ERROR);
            });
          })
          .finally(() => {
            this.loading = false;
          });
      }
    },

    // モーダルを閉じる
    closeModal: function () {
      this.showModal = false;
    },
    // yyyy/mm/ddフォーマット変換
    formatDate(dateStr) {
      if (!dateStr) return '';
      const [yyyy, mm, dd] = dateStr.split('-');
      return `${yyyy}/${mm}/${dd}`;
    },
    // 承認状態の識別
    statusColor(status) {
      switch (status) {
        case ConstList.REJECT:
        case ConstList.UNSUBMITTED: 
          return { color: 'red' };
        case ConstList.APPROVAL_PENDING:
          return { color: 'orange' };
        case ConstList.APPROVAL:
          return { color: 'green' };
        default:
          return {};
      }
    },
  },

  // DBから各種情報を取得
  mounted: function () {
    this.callList();
    this.fetchTotalPages();
  },
};
</script>

<style scoped>
th,
td {
  white-space: nowrap;
}
td {
  vertical-align: middle;
  white-space: nowrap;
  padding-top: 0;
  padding-bottom: 0;
}
</style>
